


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { ApiItem } from '../api/item'

@Component({
  computed: mapState({
    currentNamespace: (state: any) => state.namespaces.current
  })
})
export default class MasterList extends Vue {
  @Prop() private items!: ApiItem[];
  @Prop() private route!: string;

  opened = true
}
